import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import Firebase from 'firebase';



class step3 extends Component {
    constructor() {
        super();
        this.state = {

        }
    }


    componentWillMount() {
        var offsetRef = Firebase.database().ref(".info/serverTimeOffset");
        const contex = this;
        offsetRef.on("value", function (snap) {
            var offset = snap.val();
            var estimatedServerTimeMs = new Date().getTime() + offset;
            contex.setState({ expiration: estimatedServerTimeMs + 2628000000 });
        });
    }


    createUser(client) {
        const contex = this;
        var text = this.props.client
        var empresa = text.replace(/\s/g, '');
        console.log(this.state.id)
    }

    hashCode(str) {
        var len = str.length;
        var hash = 0;
        for (var i = 1; i <= len; i++) {
            var char = str.charCodeAt((i - 1));
            hash += char * Math.pow(2, (len - i));
            hash = hash & hash; //javascript limitation to force to 32 bits
        }
        return (hash)
    }

    createAccount() {
        var adminRef = Firebase.database().ref('admin_users');
        var clientRef = Firebase.database().ref("clients");
        const contex = this;
        var text = contex.props.client
        var empresa = text.replace(/\s/g, '');
        var usuario
        console.log("creando usuario", this.props.email, this.props.password, empresa)
        Firebase.auth().createUserWithEmailAndPassword(this.props.email, this.props.password)
            .then(function (user) {
                usuario = user;
                clientRef.child(empresa).set({
                    name: contex.props.client,
                    trial: true,
                    expiration: contex.state.expiration,
                    country: contex.props.country
                }).then(resp => {
                });
                adminRef.child(user.uid).set({
                    client_id: empresa,
                    created_at: Firebase.database.ServerValue.TIMESTAMP,
                    email: contex.props.email,
                    codigo: contex.hashCode(empresa),
                    name: contex.props.name,
                    su: true
                }).then(resp => {
                    console.log("admin creado")
                }).catch(error => {
                    console.log(error)
                });
            })
            .catch(function (error) {
                var errorCode = error.code;
                var errorMessage = error.message;
                console.log(errorCode, errorMessage)
            });
        var user = Firebase.auth().currentUser;
        user.updateProfile({
            displayName: "Admin"
        }).then(function () {
            // Update successful.
        }).catch(function (error) {
            // An error happened.
        });
    }

    updateUSer(id, empresa) {
        var adminRef = Firebase.database().ref('admin_users');
        const contex = this;
        adminRef.child(id).child("codigo").set(this.hashCode(empresa)).then(resp => {
            contex.props.callBack(4)
        }).catch(error => {
            console.log(error)
        });
    }

    render() {
        return (
            <fieldset>
                <h1>Validación</h1>
                <p className="text-muted">Verifica que todos los datos ingresados sean los correctos</p>
                <br />
                <div className="form-group mb-3">
                    <label>Nombre</label>
                    <input readOnly className="form-control" type="text" name="nombre_empresa" value={this.props.name} />
                </div>
                <div className="form-group mb-3">
                    <label>Email</label>
                    <input readOnly className="form-control" type="text" name="industria" value={this.props.email} />
                </div>
                <div className="form-group mb-3">
                    <label>Empresa</label>
                    <input readOnly className="form-control" type="text" name="pais" value={this.props.client} />
                </div>
                <div className="row" style={{ position: "relative", bottom: "-101" }}>
                    <div className="col-6">
                        <button type="button" className="btn btn-primary" onClick={() => { this.props.callBack(2) }} >Atras</button>
                    </div>
                    <div className="col-6 text-right">
                        <button type="button" className="btn btn-primary" onClick={() => { this.createAccount(); }}>Validar</button>
                    </div>
                </div>
            </fieldset>
        );
    }
}
export default step3;


// WEBPACK FOOTER //
// ./src/views/register/step3.js